import { StaticImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

const Testimonials = () => (
  <div
    sx={{
      mt: [5, 0],
      py: [5, 4],
      px: 4,
      textAlign: ["center", "left"],
      border: "1px",
      borderColor: "grey",
      borderRadius: "8px",
      fontSize: 1,
      display: [null, "grid"],
      gridColumnGap: [null, 4],
      gridRowGap: [null, 4],
      gridTemplateRows: [null, "1fr 1fr"],
      gridTemplateColumns: [null, "1fr 310px"],
      gridTemplateAreas: [
        null,
        `
          "header photos"
          "footer photos"
        `,
      ],
    }}
  >
    <div sx={{ gridArea: "header", alignSelf: "flex-end" }}>
      <Heading as="h3" size="sm" sx={{ mb: 1, variant: "vwo.heading" }}>
        <Trans i18nKey="ChoosePlan.Testimonials.title" />
      </Heading>
      <Trans i18nKey="ChoosePlan.Testimonials.description" />
    </div>
    <div sx={{ gridArea: "photos" }}>
      <StaticImage
        src="../../../../images/plan-selection/testimonials.png"
        alt=""
        objectFit="contain"
        sx={{ mt: 4, borderRadius: "8px", maxWidth: [620, 310] }}
      />
      <div
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          "& > *": { flex: 1 },
        }}
      >
        <div sx={{ textAlign: "center" }}>
          <Trans i18nKey="ChoosePlan.Testimonials.startDate" />
        </div>
        <div sx={{ textAlign: "center" }}>
          <Trans i18nKey="ChoosePlan.Testimonials.endDate" />
        </div>
      </div>
    </div>
    <div sx={{ gridArea: "footer", alignSelf: "flex-start" }}>
      <div sx={{ mt: [4, 0] }}>
        <Trans i18nKey="ChoosePlan.Testimonials.customer">
          <span sx={{ fontWeight: "bold" }} />
        </Trans>
      </div>
      <div sx={{ mt: 1, color: "textDark" }}>
        <Trans i18nKey="ChoosePlan.Testimonials.reviews" />
      </div>
    </div>
  </div>
)

export default Testimonials
